// Marketing-page footer: structured link columns + wordmark. Lives
// ABOVE the thin status Footer that the Layout always renders. Scoped
// to pages that opt in (landing, docs, changelog, status, pricing,
// security, privacy, terms) — the app views (Submit, Analyses, Report)
// skip it so they stay tool-dense.
import { Link } from "react-router-dom";

type Col = { head: string; links: { to?: string; href?: string; label: string; external?: boolean }[] };

const COLS: Col[] = [
  {
    head: "Product",
    links: [
      { to: "/submit", label: "Submit a sample" },
      { to: "/jobs", label: "Recent analyses" },
      { to: "/status", label: "Fleet status" },
      { to: "/changelog", label: "Changelog" },
    ],
  },
  {
    head: "Docs",
    links: [
      { to: "/docs", label: "Quickstart" },
      { to: "/docs#interact", label: "Interact with a run" },
      { to: "/docs#report", label: "Read a report" },
      { to: "/docs#self-host", label: "Self-host" },
    ],
  },
  {
    head: "Company",
    links: [
      { to: "/pricing", label: "Pricing" },
      { to: "/security", label: "Security" },
      { href: "mailto:neel@neels.dev", label: "Contact" },
    ],
  },
  {
    head: "Legal",
    links: [
      { to: "/privacy", label: "Privacy" },
      { to: "/terms", label: "Terms" },
      { href: "/.well-known/security.txt", label: "security.txt" },
    ],
  },
  {
    head: "Follow",
    links: [
      { href: "mailto:neel@neels.dev", label: "Email" },
    ],
  },
];

export function BigFooter() {
  return (
    <footer className="mt-20 border-t border-rule-strong bg-paper" aria-label="Site footer">
      <div className="mx-auto grid max-w-[1200px] gap-10 px-5 py-12 sm:grid-cols-2 sm:px-8 md:grid-cols-5">
        <div className="min-w-0 md:col-span-1">
          <Link to="/" viewTransition className="font-mono text-ink" style={{ fontSize: "22px", letterSpacing: "-0.02em" }}>
            malbox
          </Link>
          <p className="mt-3 max-w-[220px] text-meta text-ink-soft">
            The analyst-grade malware sandbox. In beta.
          </p>
        </div>
        {COLS.map((c) => (
          <div key={c.head} className="min-w-0">
            <p className="lens-eyebrow">{c.head}</p>
            <ul className="mt-3 space-y-2">
              {c.links.map((l) => (
                <li key={l.label}>
                  {l.to ? (
                    <Link to={l.to} viewTransition className="text-ui text-ink hover:underline">
                      {l.label}
                    </Link>
                  ) : (
                    <a
                      href={l.href}
                      target={l.external ? "_blank" : undefined}
                      rel={l.external ? "noopener noreferrer" : undefined}
                      className="text-ui text-ink hover:underline"
                    >
                      {l.label}
                      {l.external ? " ↗" : ""}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </footer>
  );
}
